import React from "react";

import SvgI24Details from "assets/icons/I24Details";

import { Button, Typography } from "@material-ui/core";

import Placeholder from "components/Placeholder";

import {
  Container,
  ImageContainer,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  BottomControlsContainer,
  ControlWrapper,
} from "./styles";

type Props = {
  title: string;
  onDetailsClick: () => void;
};

class CategoryCard extends React.Component<Props> {
  render() {
    const { title, onDetailsClick } = this.props;

    return (
      <Container>
        <ImageContainer>
          <Placeholder height={162} width={162} />
        </ImageContainer>
        <DetailsContainer>
          <TextContainer>
            <TitleWrapper>
              <Typography variant="h3" color="textPrimary">
                {title}
              </Typography>
            </TitleWrapper>
          </TextContainer>
          <BottomControlsContainer>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Details />}
                variant="text"
                color="secondary"
                onClick={onDetailsClick}
              >
                Details
              </Button>
            </ControlWrapper>
          </BottomControlsContainer>
        </DetailsContainer>
      </Container>
    );
  }
}

export default CategoryCard;
